/**
 * Check if string is null, empty or only contains whitespaces
 * @param {string|null} str string to check
 * @returns {boolean} Result of whether string is null or whitespace
 */
export function isStringNullOrWhiteSpace(str?: string | null) {
  return str == null || (typeof str === 'string' && str.replace(/\s/g, '') === '');
}
